import { ReactComponent as NoteIndicationAttachedOrInProgress } from "assets/svg/note-indication-attached-or-in-progress.svg";
import { ReactComponent as NoteIndicationSignedAndSubmitted } from "assets/svg/note-indication-signed-and-submitted.svg";
import messages from "messages";
import moment from "moment-timezone";
import { useMemo } from "react";
import styles from "./NoteListItem.module.scss";
import sessionSidesheetStyles from "../../SessionSidesheet.module.scss";
import getClasses from "utils/getClasses";
import { OPEN_NOTE_FROM_CALENDAR_IN_THE_SAME_TAB } from "constants/featureFlags";

interface NoteListItemProps {
  note: NoteDataInfo;
  trackClick: (elementName: string) => void;
  isSessionCancelled?: boolean;
  appointmentId: string | number;
}

const formatDate = (date: string) => moment(date).format("MM/DD/YY");

const NoteListItem = ({
  note,
  trackClick,
  isSessionCancelled = false,
  appointmentId,
}: NoteListItemProps) => {
  const isSubmitted = useMemo(
    () => !!note.sign_timestamp,
    [note.sign_timestamp],
  );

  const dateCopy = useMemo(
    () =>
      `${isSubmitted ? messages.submitted : messages.drafted} ${formatDate(
        note.sign_timestamp ?? note.create_timestamp,
      )}`,
    [isSubmitted, note.create_timestamp, note.sign_timestamp],
  );

  const noteLink = useMemo(
    () => `/pro-dashboard/session-review/${appointmentId}`,
    [appointmentId],
  );

  return (
    <div
      className={getClasses(
        styles["container"],
        isSessionCancelled && styles["container--disabled"],
      )}
    >
      {isSubmitted ? (
        <NoteIndicationSignedAndSubmitted
          className={getClasses(
            isSessionCancelled && sessionSidesheetStyles["disabled-icon"],
          )}
        />
      ) : (
        <NoteIndicationAttachedOrInProgress
          className={getClasses(
            isSessionCancelled && sessionSidesheetStyles["disabled-icon"],
          )}
        />
      )}
      <span className={styles["schema-title"]}>
        {OPEN_NOTE_FROM_CALENDAR_IN_THE_SAME_TAB ? (
          <a href={noteLink} onClick={() => trackClick("note-list-item-link")}>
            {note.note_schema_title}
          </a>
        ) : (
          <a
            href={noteLink}
            onClick={() => trackClick("note-list-item-link")}
            target="_blank"
            rel="noopener noreferrer"
          >
            {note.note_schema_title}
          </a>
        )}
      </span>
      {dateCopy}
    </div>
  );
};

export default NoteListItem;
